import { useEffect, useSyncExternalStore } from 'react'

/**
 * Запрет на самовольную перезагрузку страницы (обновление клиента, FB43): пока на экране открыт чек или идёт
 * оплата, плашка «Вышла новая версия» не перезагружает страницу сама и предупреждает человека.
 * Счётчик на уровне модуля: окон с открытым чеком может быть несколько. Не состояние сервера и не слайс —
 * живёт, пока открыт экран, поэтому в хранилища не попадает.
 */
let blockers = 0
const listeners = new Set<() => void>()

function emit(): void {
  for (const listener of listeners) listener()
}

/** Экран объявляет: пока `active`, страницу перезагружать нельзя. */
export function useReloadBlock(active: boolean): void {
  useEffect(() => {
    if (!active) return undefined
    blockers += 1
    emit()
    return () => {
      blockers -= 1
      emit()
    }
  }, [active])
}

/** Есть ли сейчас экран, который просит не перезагружать страницу. */
export function useReloadBlocked(): boolean {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener)
      return () => listeners.delete(listener)
    },
    () => blockers > 0,
    () => false,
  )
}
